export default __webpack_public_path__ + "static/media/smspeedrunninglogo.99a0fc64.png";